'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _style = require('styled-jsx/style');

var _style2 = _interopRequireDefault(_style);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _TheScoreContentCardSource = require('./TheScoreContentCardSource.css');

var _TheScoreContentCardSource2 = _interopRequireDefault(_TheScoreContentCardSource);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TheScoreContentCardSource = function TheScoreContentCardSource(props) {
  return _react2.default.createElement(
    'div',
    {
      role: 'img',
      'aria-label': 'theScore',

      style: props.styleOverrides ? props.styleOverrides.theScoreContentCardSourceStyles : null,
      className: 'jsx-' + _TheScoreContentCardSource2.default.__scopedHash + ' ' + 'icon'
    },
    _react2.default.createElement(_style2.default, {
      styleId: _TheScoreContentCardSource2.default.__scopedHash,
      css: _TheScoreContentCardSource2.default.__scoped
    })
  );
};

TheScoreContentCardSource.propTypes = {
  styleOverrides: _propTypes2.default.shape({
    // eslint-disable-next-line react/forbid-prop-types
    theScoreContentCardSourceStyles: _propTypes2.default.object
  })
};

TheScoreContentCardSource.defaultProps = {
  styleOverrides: null
};

exports.default = TheScoreContentCardSource;